import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Card, CardContent } from '../../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { BarChart2, Cable, TrendingUp, Gauge } from 'lucide-react';
import { getMaterialTraceabilityAllSummary } from '../../../redux/Project/materialsData/action';
import { PipeDashboardSummary } from '../components/PipeDashboardSummary';

type AnalysisTab = 'pipe-dashboard' | 'production' | 'quality';

export const AnalysisPage: React.FC = () => {
  const [analysisTab, setAnalysisTab] = useState<AnalysisTab>('pipe-dashboard');
  const dispatch = useDispatch();

  useEffect(() => {
    if (analysisTab === 'pipe-dashboard') {
      dispatch(getMaterialTraceabilityAllSummary({}));
    }
  }, [analysisTab, dispatch]);

  return (
    <div className="p-6">
      <Card className="border-none shadow-none">
        <CardContent className="p-6">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-900">Analysis</h2>
            <p className="text-sm text-gray-500 mt-1">View analytics and insights for your pipeline data</p>
          </div>

          <Tabs
            className="w-full"
            value={analysisTab}
            onValueChange={(value) => setAnalysisTab(value as AnalysisTab)}
          >
            <div className="sticky top-0 bg-white rounded-t-lg z-10 border-b border-gray-200">
              <TabsList className="h-12 w-full justify-start gap-8 border-b border-gray-200 bg-transparent px-0 py-10">
                <TabsTrigger
                  className="data-[state=active]:border-[#e04530] data-[state=active]:text-[#e04530] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                  value="pipe-dashboard"
                >
                  <Cable className="h-4 w-4 mr-2" />
                  Pipe Dashboard
                </TabsTrigger>
                {/* <TabsTrigger
                  className="data-[state=active]:border-[#e04530] data-[state=active]:text-[#e04530] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                  value="production"
                >
                  <TrendingUp className="h-4 w-4 mr-2" />
                  Production Analytics
                </TabsTrigger>
                <TabsTrigger
                  className="data-[state=active]:border-[#e04530] data-[state=active]:text-[#e04530] relative px-1 pb-3 pt-2 text-base font-medium text-gray-500 hover:text-gray-700 data-[state=active]:border-b-[0.5px]"
                  value="quality"
                >
                  <Gauge className="h-4 w-4 mr-2" />
                  Quality Metrics
                </TabsTrigger> */}
              </TabsList>
            </div>

            <TabsContent value="pipe-dashboard" className="mt-6">
              <PipeDashboardSummary />
            </TabsContent>

            <TabsContent value="production" className="mt-6">
              <Card className="border border-gray-200 bg-white">
                <CardContent className="p-8">
                  <div className="flex flex-col items-center justify-center py-12 text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                      <TrendingUp className="h-8 w-8 text-gray-400" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Production Analytics</h3>
                    <p className="text-gray-500 max-w-sm">
                      Production trends and analytics will appear here.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            <TabsContent value="quality" className="mt-6">
              <Card className="border border-gray-200 bg-white">
                <CardContent className="p-8">
                  <div className="flex flex-col items-center justify-center py-12 text-center">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                      <Gauge className="h-8 w-8 text-gray-400" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Quality Metrics</h3>
                    <p className="text-gray-500 max-w-sm">
                      Quality metrics and compliance data will appear here.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};
